import React from 'react'
import Card from '@material-ui/core/Card'
import Typography from '@material-ui/core/Typography'
import { Theme, makeStyles } from '@material-ui/core/styles'
import Paper from 'components/Paper'
import Match from 'components/Match'
import T from 'components/FormattedMessage'
import Countdown from 'components/Countdown'
import BetOffer from 'components/BetOffer'
import { MatchPeriodToken } from 'lib/enumTranslations'
import formatMatchMinute from 'lib/formatMatchMinute'
import { IMatch, MatchStatus } from 'protos'
import classNames from 'classnames'

interface Props {
  match: IMatch
  className?: string
}

interface StyleProps {
  isLive: boolean
}

const useStyles = makeStyles<Theme, StyleProps>(theme => ({
  root: {
    fontSize: 14,
    backgroundColor: 'transparent',
    textAlign: 'center',
    filter: 'drop-shadow(0px 0px 10px rgba(0, 0, 0, .1))',
    WebkitFilter: 'drop-shadow(0px 0px 10px rgba(0, 0, 0, .1))',
  },
  header: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(),
    ...theme.components.MatchCard.header
  },
  footer: {
    padding: theme.spacing(),
    borderTop: '1px solid rgba(0, 0, 0, .1)',
    backgroundColor: '#F9F9F9',
    ...theme.components.MatchCard.footer
  },
  countdown: ({ isLive }) => ({
    opacity: isLive ? 1 : 0.3,
    color: isLive ? theme.palette.primary.main : theme.palette.text.primary,
  })
}))



const MatchCard: React.SFC<Props> = ({ match, className, ...props }) => {
  const classes = useStyles({
    isLive: match.status === MatchStatus.MS_LIVE
  })

  return (
    <Card {...props} elevation={0} className={classNames(className, classes.root)}>
      <Paper elevation={0} className={classes.header}>
        <Match match={match} />
      </Paper>
      <Paper elevation={0} className={classes.footer}>
        {
          match.betOffer
            ? <BetOffer betOffer={match.betOffer} />
            : (
              <Typography className={classes.countdown}>
                {match.status === MatchStatus.MS_UPCOMING && (
                  <>
                    <T id="game_countdown" /> <Countdown remainingSec={match.kickoffRemainingSec} />
                  </>
                )}
                {match.status === MatchStatus.MS_LIVE && (
                  <>
                    {formatMatchMinute(match.clock)}
                    {' - '}
                    <T id={MatchPeriodToken(match.period!)} />
                  </>
                )}
                {match.status === MatchStatus.MS_FINISHED && <T id="matchstatus_finished" />}
                {match.status === MatchStatus.MS_CANCELLED && <T id="matchstatus_cancelled" />}
              </Typography>
            )
        }
      </Paper>
    </Card>
  )
}

export default MatchCard
